export const name = 'saveDialogController';
export default function saveDialogController($scope, $log, $mdDialog, $timeout) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let vm = this;
  vm.updating = true;
  vm.successfullyUpdated = false;
  vm.failedUpdated = false;
  vm.updatedTemplate = null;
  vm.close = close;

  (function save() {
    let startTime = new Date().getMilliseconds();
    vm.saveFunction(vm.updatedValues, vm.updatedPdfPresetValues).then(
      function (preset) {
        let timePassed = new Date().getMilliseconds() - startTime;
        if(timePassed < 2000){
          $timeout(()=>{
            vm.updating = false;
            $mdDialog.hide(preset);
          }, 2000 - timePassed);
        }else{
          vm.updating = false;
          $mdDialog.hide(preset);
        }
      },
      function (error) {
        vm.updating = false;
        vm.failedUpdated = true;
      }
    );
  }());

  function close() {
    $mdDialog.cancel();
  }
}
